export const RatingBadge = ({ v }) => {
  if (!v) return null;
  const cls = {
    A: "bg-emerald-100 text-emerald-800 border-emerald-300",
    B: "bg-sky-100 text-sky-800 border-sky-300",
    C: "bg-amber-100 text-amber-800 border-amber-300",
    N: "bg-zinc-100 text-zinc-500 border-zinc-200",
  }[v.rating] || "bg-zinc-100 text-zinc-500 border-zinc-200";
  return (
    <span title={v.reason} data-testid={`rating-badge-${v.rating}`}
      className={`inline-flex items-center justify-center w-5 h-5 rounded border text-[11px] font-bold cursor-help ${cls}`}>
      {v.rating}
    </span>
  );
};
